import React, { useState } from "react";
import { Card, Button, Typography, Space, Row, Col, Form, Input, message } from "antd";
import { PhoneOutlined, MailOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "../utils/axiosConfig";
import "./SubscriptionExpired.css";
import logger from "../utils/logger";

const { Title, Paragraph, Text } = Typography;

const ContactSupport = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post("/support/contact", values);

      if (response.data.success) {
        message.success("تم إرسال رسالتك بنجاح، سنتواصل معك قريباً");
        form.resetFields();
      } else {
        message.error("فشل في إرسال الرسالة، يرجى المحاولة مرة أخرى");
      }
    } catch (error) {
      logger.error("Error sending support request:", error);
      message.error("حدث خطأ في إرسال الرسالة، يرجى المحاولة مرة أخرى");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-expired-container">
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "100vh", padding: "20px" }}
      >
        <Col xs={24} sm={22} md={20} lg={18} xl={16}>
          <Card
            className="subscription-expired-card"
            bordered={false}
            style={{
              textAlign: "center",
              borderRadius: 16,
              boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
            }}
          >
            <Space
              direction="vertical"
              size="large"
              style={{ width: "100%" }}
            >
              <div style={{ marginTop: 20 }}>
                <CustomerServiceOutlined
                  style={{ fontSize: 64, color: "#1890ff" }}
                />
              </div>

              <Title level={2}>تواصل مع الدعم الفني</Title>
              <Paragraph style={{ fontSize: 16, color: "#666" }}>
                فريق الدعم جاهز لمساعدتك في حل أي مشكلة تواجهها.
                يرجى ملء النموذج أدناه وسنتواصل معك في أقرب وقت ممكن.
              </Paragraph>

              <div style={{ textAlign: "right", margin: "20px 0" }}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card size="small" style={{ textAlign: "center" }}>
                      <PhoneOutlined style={{ fontSize: 24, color: "#1890ff" }} />
                      <div style={{ marginTop: 8 }}>
                        <Text strong>هاتف الدعم</Text>
                        <div>+9647889702444</div>
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card size="small" style={{ textAlign: "center" }}>
                      <MailOutlined style={{ fontSize: 24, color: "#1890ff" }} />
                      <div style={{ marginTop: 8 }}>
                        <Text strong>البريد الإلكتروني</Text>
                        <div>almarjeapro@gmail.com</div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>

              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                style={{ textAlign: "right", marginTop: 20 }}
              >
                <Form.Item
                  name="subject"
                  label="الموضوع"
                  rules={[{ required: true, message: "يرجى إدخال الموضوع" }]}
                >
                  <Input placeholder="موضوع رسالتك" />
                </Form.Item>

                <Form.Item
                  name="message"
                  label="الرسالة"
                  rules={[{ required: true, message: "يرجى إدخال الرسالة" }]}
                >
                  <Input.TextArea rows={4} placeholder="اكتب رسالتك هنا..." />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    إرسال الرسالة
                  </Button>
                </Form.Item>
              </Form>

              <div style={{ marginTop: 20 }}>
                <Button onClick={() => navigate("/login")}>
                  العودة لتسجيل الدخول
                </Button>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactSupport;
